export enum OrderDetailsViewType {
  Timeline,
  Board,
  Grid
}
